import { Globe, Envelope, ShieldCheck, Sparkle } from '@phosphor-icons/react';

const BENEFITS = [
  {
    icon: Globe,
    title: 'Reach more guests',
    description: 'List once and get discovered by travellers browsing BestAcco for hotels with soul.',
  },
  {
    icon: Envelope,
    title: 'Bookings come to you',
    description: 'Guests book with you directly, with no middlemen taking a cut of every stay.',
  },
  {
    icon: ShieldCheck,
    title: 'Curated and verified',
    description: 'We review and verify every hotel, so a place on BestAcco means something to guests.',
  },
  {
    icon: Sparkle,
    title: 'Simple to start',
    description: 'Tell us about your hotel and our team takes it from there. No PMS account required.',
  },
];

/**
 * Top of /list-your-property: the value pitch + a primary CTA that scrolls to
 * the on-page lead form. BestAcco is a curated directory, so listing is a
 * submission reviewed by the BestAcco team. It does not route into the PMS,
 * which is a separate add-on product.
 */
export function PartnerValueSection() {
  return (
    <section className="relative isolate overflow-hidden bg-ink text-cream">
      <div className="px-6 py-20 sm:px-10 lg:px-16 lg:py-24 2xl:px-24">
        <div className="max-w-2xl">
          <h1 className="font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            List your hotel on BestAcco.
          </h1>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-cream/80">
            Join a curated collection that travellers trust. Tell us about your hotel
            and our team reviews every submission before it goes live. No PMS to set up,
            just direct bookings straight to you.
          </p>
          <div className="mt-8">
            <a
              href="#lead-form"
              className="inline-flex items-center justify-center rounded-xl bg-clay px-7 py-3.5 font-semibold text-white transition hover:bg-clay-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
            >
              Tell us about your hotel
            </a>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map((b) => (
            <div key={b.title} className="rounded-2xl bg-cream/10 p-6 backdrop-blur">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-cream text-clay">
                <b.icon className="h-5 w-5" />
              </span>
              <h2 className="mt-4 font-serif text-xl font-semibold">{b.title}</h2>
              <p className="mt-1.5 text-sm text-cream/70">{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
